import { useState } from "react";
import { Button } from "@/components/ui/button";
import { openLeadForm } from "@/lib/lead-form";

const LeadVideoSection = () => {
  const [isVideoPlayerLoaded, setIsVideoPlayerLoaded] = useState(false);

  return (
    <section className="bg-primary py-10 md:py-14">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-5 max-w-4xl text-white md:mb-6">
          <h2 className="mt-2 text-2xl font-bold leading-tight md:text-3xl">
            Chega de estar divorciado lá fora e casado no Brasil
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/85 md:text-base">
            Veja como validar sua sentença estrangeira no Brasil sem precisar viajar
          </p>
        </div>

        <div className="mx-auto max-w-4xl overflow-hidden rounded-xl border border-white/20 bg-black/30 shadow-xl backdrop-blur-sm">
          <div className="aspect-video">
            {isVideoPlayerLoaded ? (
              <iframe
                className="h-full w-full"
                src="https://www.youtube-nocookie.com/embed/mNwn7yF1WKM?autoplay=1"
                title="Vídeo de apresentação do atendimento jurídico"
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : (
              <button
                type="button"
                className="group relative h-full w-full"
                onClick={() => setIsVideoPlayerLoaded(true)}
                aria-label="Reproduzir vídeo de apresentação"
              >
                <img
                  src="https://i.ytimg.com/vi/mNwn7yF1WKM/hqdefault.jpg"
                  alt="Thumbnail do vídeo de apresentação"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/35 transition-colors group-hover:bg-black/45" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent px-4 pb-4 pt-10 text-left text-white">
                  <p className="text-sm font-semibold md:text-base">
                     O caminho para sua liberdade civil no Brasil
                  </p>
                  <p className="mt-1 text-xs text-white/85 md:text-sm">
                   Regularize seu estado civil de forma presencial ou online
                  </p>
                </div>
                <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-primary shadow-lg transition-transform group-hover:scale-105">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="ml-1 h-8 w-8"
                    aria-hidden="true"
                  >
                    <path d="M8 5.14v14l11-7-11-7Z" />
                  </svg>
                </span>
              </button>
            )}
          </div>
        </div>

        <div className="mx-auto mt-5 flex max-w-4xl flex-col items-start gap-3 md:mt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-white/85">
            Agende uma reunião para avaliação técnica do seu caso.
          </p>
          <Button
            size="lg"
            variant="gold"
            className="w-full font-semibold md:w-auto"
            onClick={openLeadForm}
          >
            Falar com Especialista
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LeadVideoSection;
